<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong
            >Find your Career Center or Connect to your local career
            center</strong
          >
        </h5>
        <div class="ts-app-shell--header_actions flexed"></div>
      </div>
      <p>
        This is the area where you can search for the Career Center that you are
        currently connected to! Not connected to a Career Center yet? Then
        search for a Career Center that’s close by and connect with them to help
        build your connections and connect to staff.
      </p>
      <!-- <br/> -->
      <hr />
      <div class="appear-div">
        <el-row :gutter="20">
          <el-col :xl="14" :lg="14" :md="14" :sm="24" :xs="24">
            <h6>Appear in Staff Searches for Job Seekers?</h6>
            <p>
              Do you want to appear in staff search results as a job seekers in
              their area? <br />
              If you are set to show, a staff will be able to request a
              connection with you <br />
              You can change this at any time and being set to hidden will not
              stop you from reaching out to a Career Center of your choice
            </p>
          </el-col>
          <el-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24">
            <el-radio-group
              v-model="caseworkerSearchStatus"
              @change="toggleSearchStatus"
              class="groupclass"
              style="margin-top: 25px;"
            >
              <el-radio-button label="Hide from Searches"></el-radio-button>
              <el-radio-button label="Show in Searches"></el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
    </div>
    &nbsp;
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-row :gutter="20">
          <el-col :span="24"> </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :xl="5"
            :lg="5"
            :md="24"
            :sm="24"
            :xs="24"
            style="text-align:center"
          >
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="findAgency">
                <h6 class="card-font">
                  Find an <br />
                  Career Center
                </h6>
                <div class="dash-card">
                  <i class="fas fa-search"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >Search</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24" :offset="1">
            <h6 class="card-font">Find a Career Center &amp; Connect</h6>
            <br />
            <p>
              If you are currently working with a staff from a Career Center or
              want to find a Career Center and be assigned a staff, search here
              with a zip code and start building connections now
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :xl="5"
            :lg="5"
            :md="24"
            :sm="24"
            :xs="24"
            style="text-align:center"
          >
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="connectedAgencies">
                <h6 class="card-font">
                  Connected <br />
                  Career Centers
                </h6>
                <div class="dash-card">
                  <i class="fas fa-handshake"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >View
                    </el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24" :offset="1">
            <h6 class="card-font">Connected Career Centers &amp; Staff</h6>
            <br />
            <p>
              View the list of Career Centers whom you are connected with and
              manage your assigned staff. Watch as your connections help gain
              more opportunities and potential job offers.
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :xl="5"
            :lg="5"
            :md="24"
            :sm="24"
            :xs="24"
            style="text-align:center"
          >
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="manageAgencyRequests">
                <h6 class="card-font">
                  Manage <br />
                  Requests
                </h6>
                <div class="dash-card">
                  <i class="far fa-envelope"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >Manage
                    </el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24" :offset="1">
            <h6 class="card-font">
              Manage &amp; Monitor Requests to Career Centers
            </h6>
            <br />
            <p>
              Manage and monitor any requests that you have sent to Career
              Centers within your area and even further! Reach out to Career
              Centers in the hope to be assigned a staff, or find the Career
              Center you already have a connection with and be assigned your
              staff.
            </p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("jobseeker/getcaseworkersearchstatus").then(res => {
      if (res == 1) this.caseworkerSearchStatus = "Hide from Searches";
      else this.caseworkerSearchStatus = "Show in Searches";
    });
  },
  data() {
    return {
      caseworkerSearchStatus: "Show in Searches"
    };
  },
  methods: {
    findAgency() {
      this.$router.push({ name: "search-agency" });
    },
    manageAgencyRequests() {
      this.$router.push({ name: "manage-agency-requests" });
    },
    connectedAgencies() {
      this.$router.push({ name: "connected-agencies-caseworkers" });
    },
    toggleSearchStatus() {
      if (this.caseworkerSearchStatus == "Hide from Searches") {
        this.$confirm(
          "Are you sure you want to remain hidden from staff’s job seekers searches? <br/> If you have already been assigned a staff, it will be up to you to connect with their Career Center if you can't be found in the searches.",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        )
          .then(() => {
            this.$store
              .dispatch("jobseeker/updatecaseworkersearchstatus", 1)
              .then(res => {
                this.$message.success("Search status updated successfully!");
              });
          })
          .catch(() => {
            this.caseworkerSearchStatus = "Show in Searches";
          });
      } else {
        this.$store
          .dispatch("jobseeker/updatecaseworkersearchstatus", 0)
          .then(res => {
            this.$message.success("Search status updated successfully!");
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header-text {
  font-size: 14px;
  line-height: 1.6;
  font-weight: 500;
}

.appear-div {
  padding: 10px;
  background-image: url(/img/div-bg-welcome.7c1bb5d5.png);
}

span {
  width: 100% !important;
}

@media screen and (max-width: 759px) {
  .card-font {
    margin-top: 20px !important;
  }

  p {
    margin-right: 10px !important;
  }
}
</style>
